import { Text } from '@consta/uikit/Text'
import type { StatisticsColumn } from '@core/core/types'
import type { FC } from 'react'

import css from './Statistics.css'
import { StatisticsRow } from './StatisticsRow'

export const StatisticsBlock: FC<StatisticsColumn & { text: string }> = ({
  min,
  max,
  std,
  pointsCount,
  text,
}) => (
  <div>
    <Text className={css.statisticsHeader} size="xs" view="ghost">
      {text}
    </Text>
    <div className={css.statisticsDataBlock}>
      <StatisticsRow label="Минимум, абс" value={min} />
      <StatisticsRow label="Максимум, абс" value={max} />
      <StatisticsRow label="STD" value={std} />
      <StatisticsRow label="Кол-во скважин" value={pointsCount} />
    </div>
  </div>
)
